import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import PageHero from '../components/ui/PageHero';
import StoreButtons from '../components/ui/StoreButtons';

const IOS_STORE = 'https://apps.apple.com/us/app/strapin/id6739948260';
const ANDROID_STORE = 'https://play.google.com/store/apps/details?id=com.strapin.chainsapp';

/** X blocks automatic redirects to app stores; user taps on store links work. */
function isXInAppBrowser() {
  const ua = navigator.userAgent || '';
  const referrer = document.referrer || '';

  const fromXReferrer = /(?:^|\/\/)(?:www\.)?(?:twitter\.com|x\.com|t\.co)(?:\/|$)/i.test(referrer);
  const xUserAgent = /Twitter(?:Android|iPhone|iPad)?|Twitter for (?:iPhone|iPad|Android)/i.test(ua);

  return fromXReferrer || xUserAgent;
}

function isOtherInAppBrowser() {
  const ua = navigator.userAgent || navigator.vendor || window.opera || '';
  return /Instagram|FBAN|FBAV|LinkedIn/i.test(ua);
}

function Download() {
  const [shouldShowPage, setShouldShowPage] = useState(false);
  const [openedFromX, setOpenedFromX] = useState(false);

  useEffect(() => {
    const ua = navigator.userAgent || navigator.vendor || window.opera;
    const isiOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
    const isAndroid = /android/i.test(ua);

    if (isXInAppBrowser()) {
      setOpenedFromX(true);
      setShouldShowPage(true);
      return;
    }

    if (isOtherInAppBrowser()) {
      if (isiOS) {
        window.location.replace(IOS_STORE);
        return;
      }
      if (isAndroid) {
        window.location.replace(ANDROID_STORE);
        return;
      }
      setShouldShowPage(true);
      return;
    }

    if (isiOS) {
      window.location.replace(IOS_STORE);
      return;
    }

    if (isAndroid) {
      window.location.replace(ANDROID_STORE);
      return;
    }

    setShouldShowPage(true);
  }, []);

  if (!shouldShowPage) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-onyx">
        <div className="text-center">
          <div className="mx-auto mb-4 h-12 w-12 animate-spin rounded-full border-2 border-primary border-t-transparent" />
          <p className="text-lg text-mist">Taking you to the app store…</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-onyx text-mist">
      <Header />
      <PageHero
        tag="Download Strapin Now"
        description={
          openedFromX
            ? 'Tap your store below to download Strapin. X’s browser blocks automatic redirects — a tap opens the App Store or Google Play.'
            : 'Download Strapin — the privacy-first app built by and for gay and queer men. No screenshots. No data selling. Real connections.'
        }
      >
        <StoreButtons size="lg" />
        {openedFromX && (
          <p className="mt-4 max-w-md text-center text-sm text-silver">
            Or tap <span className="text-mist">⋯</span> in X and choose <strong className="text-mist">Open in browser</strong>, then revisit this link.
          </p>
        )}
      </PageHero>

      <section className="site-container pb-24">
        <div className="mx-auto flex max-w-2xl flex-wrap justify-center gap-6">
          {[
            ['📍', 'Nearby profiles'],
            ['📁', 'Private albums'],
            ['🚫', 'Zero data selling'],
          ].map(([icon, label]) => (
            <div key={label} className="glass-card flex items-center gap-2 px-5 py-3 text-sm text-silver">
              <span>{icon}</span>
              <span>{label}</span>
            </div>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Download;
